export const LISTING_TYPES = ["For sale", "For rent", "Short stay"];

// Short enough to sit in a phone-width filter row.
export const LISTING_TYPE_SHORT = {
  en: { "For sale": "Sale", "For rent": "Rent", "Short stay": "Stays" },
  es: { "For sale": "Venta", "For rent": "Alquiler", "Short stay": "Estadías" },
};

export const PROPERTY_TYPES = ["Villa", "House", "Condo", "Apartment", "Penthouse", "Hotel", "Land", "Commercial"];

export const LISTING_TYPE_ES = { "For sale": "En venta", "For rent": "En alquiler", "Short stay": "Estadía corta" };

/** A house booked by the night — how a visitor stays on the island. */
export const isStay = (listing) => listing?.listing_type === "Short stay";

/** "/night", "/month" or nothing, in the reader's language. */
export const priceSuffix = (listingType, es) => {
  if (listingType === "Short stay") return es ? "/noche" : "/night";
  if (listingType === "For rent") return es ? "/mes" : "/mo";
  return "";
};
export const PROPERTY_TYPE_ES = {
  Villa: "Villa",
  House: "Casa",
  Condo: "Condominio",
  Apartment: "Apartamento",
  Penthouse: "Penthouse",
  Hotel: "Hotel",
  Parador: "Parador",
  Guesthouse: "Posada",
  Hostel: "Hostal",
  Cabin: "Cabaña",
  Camping: "Campamento",
  Glamping: "Glamping",
  "Eco lodge": "Eco albergue",
  "Unique stay": "Estadía única",
  Land: "Terreno",
  Commercial: "Comercial",
};

/** The areas the island's stays sit in, offered in the stay search. */
export const STAY_AREAS = [
  "Adjuntas", "Cabo Rojo", "Culebra", "Guánica", "Isabela", "Maricao", "Rincón",
  "San Juan", "Utuado", "Vieques",
];

export const ESTATE_AREAS = [
  "Condado", "Old San Juan", "Miramar", "Puerta de Tierra", "Santurce", "Ocean Park", "Río Piedras", "Guaynabo",
  "Dorado", "Palmas del Mar", "Rincón", "Isabela", "Vieques", "Culebra", "Ponce",
];

export const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return "Price on request";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Number(value));
};

export const slugify = (text) =>
  String(text || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 90);

export const coverOf = (listing) => listing?.cover_image || (listing?.images || [])[0] || "";

// The centre of each market the guide lists, so a property with only a
// neighbourhood named still lands somewhere sensible on the map.
export const AREA_COORDS = {
  "Condado": [18.454, -66.0706],
  "Old San Juan": [18.4655, -66.1057],
  "Miramar": [18.4597, -66.0847],
  "Puerta de Tierra": [18.4643, -66.0954],
  "Santurce": [18.448, -66.056],
  "Ocean Park": [18.4495, -66.027],
  "Río Piedras": [18.399, -66.05],
  "Guaynabo": [18.383, -66.115],
  "Dorado": [18.4589, -66.2677],
  "Palmas del Mar": [18.086, -65.796],
  "Rincón": [18.34, -67.25],
  "Isabela": [18.501, -67.024],
  "Vieques": [18.126, -65.44],
  "Culebra": [18.303, -65.301],
  "Ponce": [18.011, -66.614],
};

const ISLAND = [18.2, -66.3];

const hashOf = (text) => {
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) hash = (hash * 31 + text.charCodeAt(index)) % 100000;
  return hash;
};

/**
 * Where a property sits on the map. Exact coordinates when the listing carries
 * them, otherwise its neighbourhood's centre plus a small, stable offset so two
 * places in the same area do not stack on one point.
 */
export const coordsOf = (listing) => {
  const latitude = Number(listing?.latitude);
  const longitude = Number(listing?.longitude);
  if (Number.isFinite(latitude) && Number.isFinite(longitude) && latitude && longitude) {
    return { latitude, longitude };
  }
  const base = AREA_COORDS[listing?.area] || ISLAND;
  const seed = hashOf(String(listing?.id || listing?.title || listing?.area || ""));
  return {
    latitude: base[0] + ((seed % 23) - 11) * 0.0009,
    longitude: base[1] + ((Math.floor(seed / 23) % 23) - 11) * 0.0009,
  };
};

/** A price short enough to sit inside a map pin: $1.4M, $860K, $3,200/mo. */
export const formatPriceShort = (value) => {
  const amount = Number(value);
  if (!value || !Number.isFinite(amount)) return "Price";
  const short =
    amount >= 1000000
      ? `$${(amount / 1000000).toFixed(amount % 1000000 === 0 ? 0 : 1)}M`
      : amount >= 10000
        ? `$${Math.round(amount / 1000)}K`
        : `$${Math.round(amount).toLocaleString("en-US")}`;
  return short;
};